import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { ProductVisual } from '../products/ProductVisual';
import { products } from '../../data/products';
interface FamilyScreenProps {
  onNext: () => void;
}
export function FamilyScreen({
  onNext
}: FamilyScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-801" data-mp="332tlwrs0hsya">
      <Reveal data-id="element-802" data-mp="2fgdbtjk9qfm0">
        <span className="font-body text-[10px] uppercase tracking-[0.22em] text-primary" data-id="element-803" data-mp="2ffv7s0rd6x3j">
          The family portrait
        </span>
      </Reveal>
      <Reveal delay={0.06} data-id="element-804" data-mp="2p4v9vt15y8ly">
        <h2 className="mt-2 font-heading text-[42px] leading-[0.95] tracking-[-0.02em] text-white" data-id="element-805" data-mp="2p66o6ms8iyrb">
          Meet the Filteks
        </h2>
      </Reveal>
      <Reveal delay={0.14} data-id="element-806" data-mp="2kclmajnitkmu">
        <p className="mt-3 max-w-[310px] font-body text-[15px] leading-relaxed text-white/65" data-id="element-807" data-mp="1woaq3tsrs94w">
          Three composites and one late arrival. Same heritage, different strengths
          for different jobs.
        </p>
      </Reveal>

      <Reveal delay={0.22} className="mt-8" data-id="element-808" data-mp="iwknph94zobi">
        <div className="rounded-[28px] bg-white p-4 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.6)]" data-id="element-809" data-mp="nvxbc47u0zf5">
          <div className="grid grid-cols-4 items-end gap-1" data-id="element-810" data-mp="sn5kr095wksb">
            {products.map((p, i) => <motion.div key={p.id} initial={{
            opacity: 0,
            y: 24,
            rotate: i === 0 ? -4 : i === products.length - 1 ? 4 : 0
          }} animate={{
            opacity: 1,
            y: 0,
            rotate: 0
          }} transition={{
            delay: 0.34 + i * 0.12,
            type: 'spring',
            stiffness: 240,
            damping: 20
          }} className="flex flex-col items-center" data-id="element-811" data-mp="wo91doz1akul" data-mpi={i}>
                <ProductVisual product={p.id} className="h-[126px] w-auto" data-id="element-812" data-mp="1kdjr8beuiuty" />
              </motion.div>)}
          </div>
          <div className="mt-4 grid grid-cols-4 gap-1.5 border-t border-[rgba(1,51,43,0.1)] pt-3 text-center" data-id="element-813" data-mp="1pezfsdg8fjh3">
            {products.map(p => <span key={p.id} className="font-body text-[9px] uppercase leading-tight tracking-[0.1em] text-[rgba(1,51,43,0.55)]" data-id="element-814" data-mp="3hdo2hv5gsydh">
                {p.shortName}
              </span>)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.5} className="mt-7" data-id="element-815" data-mp="32p1nxvnnwanb">
        <PillButton tone="dark" full onClick={onNext} data-id="element-816" data-mp="32nqi7qanostk">
          Introduce me
        </PillButton>
      </Reveal>
    </div>;
}